import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { clearConversationHistory } from '../../features/vibe-coding/redux/clearConversationHistory';
import { getConversations } from '../../features/vibe-coding/redux/getConversations';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';
import showAlert from '../../common/utils/alert';
import { convertTimeStampToDate } from '../../common/utils/dateUtils';
import { drapcodeIcon } from '../../common/custom/icon-library';
import InitialPromptPage from './InitialPromptPage';

export class ConversationListPage extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    history: PropTypes.object,
    location: PropTypes.object,
    match: PropTypes.object.isRequired,
    vibe: PropTypes.object.isRequired,
  };

  hasPromptOrKeys = () => {
    const search =
      (this.props.location && this.props.location.search) ||
      (typeof window !== 'undefined' ? window.location.search : '') ||
      '';
    const searchParams = new URLSearchParams(search);
    return Boolean(searchParams.get('prompt') || searchParams.get('keys'));
  };

  componentDidMount() {
    if (this.hasPromptOrKeys()) {
      return;
    }
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    if (projectId && version) {
      actions.getConversations({ projectId, version });
    }
  }

  handleDeleteConversation = (conversationId) => {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;

    const preConfirm = async () => {
      try {
        await actions.clearConversationHistory({
          projectId,
          version,
          conversationId,
        });
        actions.getConversations({ projectId, version });
      } catch (error) {
        return error;
      }
    };

    showAlert('Are you sure you want to delete this conversation?', preConfirm, 'Yes, delete it!');
  };

  render() {
    const { vibe, match, history, location } = this.props;
    const { projectId, version } = match.params;
    const { conversations, getConversationsPending } = vibe;

    const hasPromptOrKeys = this.hasPromptOrKeys();

    if (hasPromptOrKeys || !conversations || !conversations.length) {
      return (
        <InitialPromptPage
          history={history}
          location={location}
          projectId={projectId}
          version={version}
        />
      );
    }

    if (getConversationsPending) {
      return (
        <CommonPageComponent>
          <div className="text-center py-5">
            <p className="text-muted">Loading conversations...</p>
          </div>
        </CommonPageComponent>
      );
    }

    if (!conversations || !conversations.length) {
      return <InitialPromptPage history={history} projectId={projectId} version={version} />;
    }

    const newChatUrl = `/2.0/vibe-coding/${version}/v/${projectId}/chat`;

    return (
      <CommonPageComponent>
        <div className="row mx-auto">
          <ParentContentCard
            title="Previous Conversations"
            icon="vibeCoding"
            CtaComponent={
              <Link to={newChatUrl} className="btn btn-theme-submit btn-md" title="Start New Chat">
                <i className={`wb ${drapcodeIcon('add')}`} /> Start New Chat
              </Link>
            }
          >
            <div className="table-responsive">
              <table className="table table-hover table-striped">
                <thead>
                  <tr>
                    <th style={{ width: '45%' }}>Conversation</th>
                    <th style={{ width: '15%' }}>Messages</th>
                    <th style={{ width: '25%' }}>Last Active</th>
                    <th style={{ width: '15%', textAlign: 'right' }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {conversations.map((item) => {
                    const chatUrl = `/2.0/vibe-coding/${version}/v/${projectId}/chat/${item.conversationId}`;
                    const promptTitle =
                      item.firstPrompt && item.firstPrompt.length > 80
                        ? `${item.firstPrompt.substring(0, 80)}...`
                        : item.firstPrompt || `Conversation ${item.conversationId.substring(0, 8)}`;

                    return (
                      <tr key={item.conversationId} className="td-align-middle">
                        <td>
                          <Link
                            to={chatUrl}
                            className="font-weight-bold text-dark d-block"
                            title="Open conversation"
                          >
                            {promptTitle}
                          </Link>
                          <small className="text-muted font-italic">
                            ID: {item.conversationId}
                          </small>
                        </td>
                        <td>
                          <span className="badge badge-info font-weight-normal px-2 py-1">
                            {item.totalMessages} message{item.totalMessages === 1 ? '' : 's'}
                          </span>
                        </td>
                        <td>
                          <small className="text-muted">
                            {convertTimeStampToDate(item.updatedAt || item.createdAt)}
                          </small>
                        </td>
                        <td className="text-right">
                          <Link
                            to={chatUrl}
                            className="btn btn-xs btn-primary mr-2"
                            title="Open Chat"
                          >
                            <i className={`wb ${drapcodeIcon('view')}`} /> Open
                          </Link>
                          <button
                            type="button"
                            className="btn btn-xs btn-theme-delete"
                            onClick={() => this.handleDeleteConversation(item.conversationId)}
                            title="Delete conversation"
                          >
                            <i className={`wb ${drapcodeIcon('remove')}`} />
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </ParentContentCard>
        </div>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    vibe: state.vibeCoding,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ clearConversationHistory, getConversations }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ConversationListPage);
